import { AssignmentReportState, AssignmentReportActionTypes, READ_ASSIGNMENT_REPORT_DATA_REQUEST, READ_ASSIGNMENT_REPORT_DATA_SUCCESS, READ_ASSIGNMENT_REPORT_DATA_FAILURE } from "store/reducers/types/assignmentReport/assignmentReport";

const defaultState: AssignmentReportState = {
  isLoading: false,
  errorMessage: ""
};

export default function assignmentReport(state = defaultState, action: AssignmentReportActionTypes): AssignmentReportState {
  switch (action.type) {
    case READ_ASSIGNMENT_REPORT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_ASSIGNMENT_REPORT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_ASSIGNMENT_REPORT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};